
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("8ZHDV", function(module, exports) {

$parcel$export(module.exports, "JiraCommonFlag", () => (parcelRequire("gOHSJ")).JiraCommonFlag);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $gOHSJ = parcelRequire("gOHSJ");

var $6TwEp = parcelRequire("6TwEp");

});
parcelRegister("gOHSJ", function(module, exports) {

$parcel$export(module.exports, "JiraCommonFlag", () => $8f9a85e85178b852$export$1d9a3324fc0eb52);

var $5uXOq = parcelRequire("5uXOq");

var $10xFf = parcelRequire("10xFf");

var $c0dQj = parcelRequire("c0dQj");

var $59YvY = parcelRequire("59YvY");

var $6TwEp = parcelRequire("6TwEp");
const $8f9a85e85178b852$export$1d9a3324fc0eb52 = (props)=>{
    if ((0, $10xFf.shouldBeChoreographed)(props)) {
        if ((0, $c0dQj.isMobileAndInViewPanelIterationExperiment)()) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $59YvY.ChoreographerCommonFlag), props);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6TwEp.default), rest);
};

});
parcelRegister("10xFf", function(module, exports) {

$parcel$export(module.exports, "shouldBeChoreographed", () => $36201c75b4df20a7$export$a8ba9111c7eec9ac);
$parcel$export(module.exports, "environmentToEnvType", () => $36201c75b4df20a7$export$e2cf19200849be9e);

var $iZhen = parcelRequire("iZhen");

var $fG5AJ = parcelRequire("fG5AJ");
function $36201c75b4df20a7$export$a8ba9111c7eec9ac(props) {
    return (0, $fG5AJ.shouldBeChoreographed)(props);
}
function $36201c75b4df20a7$export$e2cf19200849be9e(environment) {
    switch(environment){
        case 'dev':
            return (0, $iZhen.envType).DEV;
        case 'staging':
            return (0, $iZhen.envType).STAGING;
        case 'prod':
            return (0, $iZhen.envType).PROD;
        default:
            return (0, $iZhen.envType).LOCAL;
    }
}

});
parcelRegister("fG5AJ", function(module, exports) {

$parcel$export(module.exports, "getPendoPlugin", () => $596f0fde3f3a2d5a$export$3d3a86b2d636214b);
$parcel$export(module.exports, "shouldBeChoreographed", () => $596f0fde3f3a2d5a$export$a8ba9111c7eec9ac);
$parcel$export(module.exports, "withChoreographedToggle", () => $596f0fde3f3a2d5a$export$a646002207b915ac);
$parcel$export(module.exports, "useChoreographedRender", () => $596f0fde3f3a2d5a$export$2cfd68294be82811);
$parcel$export(module.exports, "useDisableInAppMessagesForIframe", () => $596f0fde3f3a2d5a$export$a60a99a250d6a89c);

var $5uXOq = parcelRequire("5uXOq");

var $9ACoj = parcelRequire("9ACoj");
var $4zICj = parcelRequire("4zICj");
var $TTRxY = parcelRequire("TTRxY");
var $8r6xd = parcelRequire("8r6xd");

var $4R6GH = parcelRequire("4R6GH");

var $j8DrX = parcelRequire("j8DrX");

var $7qPn9 = parcelRequire("7qPn9");

var $ioD1B = parcelRequire("ioD1B");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $596f0fde3f3a2d5a$var$environment = (0, $7qPn9.toEnvironment)((0, $j8DrX.default)('ajs-environment')) ?? 'prod';
const $596f0fde3f3a2d5a$var$createChoreographerFactory = ()=>{
    if (false) return {
        useChoreographer: (..._)=>({
                startMessage: ()=>Promise.resolve((0, $TTRxY.MessageDeliveryStatus).STARTED),
                stopMessage: ()=>Promise.resolve((0, $TTRxY.MessageDeliveryStatus).STOPPED),
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                toggleMessage: ()=>Promise.resolve('')
            }),
        withChoreographedToggle: (Component)=>Component,
        shouldBeChoreographed: (props)=>false
    };
    return (0, $4zICj.choreographerFactory)((0, $TTRxY.ProductIds).JIRA, $596f0fde3f3a2d5a$var$environment);
};
let $596f0fde3f3a2d5a$var$pendoPlugin;
function $596f0fde3f3a2d5a$export$3d3a86b2d636214b(env) {
    if (!$596f0fde3f3a2d5a$var$pendoPlugin) $596f0fde3f3a2d5a$var$pendoPlugin = new (0, $8r6xd.PendoChoreographerPlugin)(env, {
        sourceProductId: (0, $TTRxY.ProductIds).JIRA
    });
    return $596f0fde3f3a2d5a$var$pendoPlugin;
}
/**
 * Stupid hack alert: useChoreographer is throwing a TS compiler error about using MessageEventType
 * internally, and not being able to resolve that name... The usual fix for this is to add the
 * offending type to the project's exports, and then import it here so that the compiler has some
 * knowledge of what that type definition is... In this case, it doesn't seem to be working, but
 * for whatever reason, I can cast the choreographerFactory's return type using nothing more than
 * the information provided by the ReturnType<typeof choreographerFactory> type above, and then
 * define the useChoreographer type as an args list that conforms to its Parameters list, and a
 * return type that conforms to its ReturnType, and that seems to work just fine. Hopefully, somebody
 * can figure out what's going wrong here, and remove this idiocy in favor of something more sane.
 */ const { useChoreographer: $596f0fde3f3a2d5a$export$9f0e2488ffd90f11, withChoreographedToggle: $596f0fde3f3a2d5a$var$withChoreographedToggleFromFactory, shouldBeChoreographed: $596f0fde3f3a2d5a$export$a8ba9111c7eec9ac } = $596f0fde3f3a2d5a$var$createChoreographerFactory();
const $596f0fde3f3a2d5a$export$a646002207b915ac = (Component, toggleableProp, toggleableContentProp)=>{
    const WithChoreographedToggleComponent = (props)=>{
        const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = (0, $ioD1B.useChoreographedStatusContext)();
        const ChoreographedComponent = (0, $5uXOq.useMemo)(()=>$596f0fde3f3a2d5a$var$withChoreographedToggleFromFactory(Component, toggleableProp), []);
        if (isAlreadyChoreographedAtAncestor || !(0, $4R6GH.fg)('jira_with_choreographed_toggle_fix')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, props);
        const propsWithContextProviderWrapper = {
            ...props
        };
        if (toggleableContentProp) {
            const { [toggleableContentProp]: toggleableContentPropValue } = propsWithContextProviderWrapper;
            if (typeof toggleableContentPropValue === 'function') // @ts-expect-error TS doesn't know this is a callback with variable params that returns ReactNode, but we do
            propsWithContextProviderWrapper[toggleableContentProp] = (...args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ioD1B.ChoreographerContextProvider), {
                    isChoreographed: true
                }, toggleableContentPropValue(...args));
            else {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const content = toggleableContentPropValue;
                // @ts-expect-error TS doesn't know this is a ReactNode, but we do
                propsWithContextProviderWrapper[toggleableContentProp] = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ioD1B.ChoreographerContextProvider), {
                    isChoreographed: true
                }, content);
            }
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ChoreographedComponent, propsWithContextProviderWrapper);
    };
    WithChoreographedToggleComponent.displayName = `WithChoreographedToggle(${Component.displayName ?? Component.name ?? 'Component'})`;
    return WithChoreographedToggleComponent;
};
const $596f0fde3f3a2d5a$export$2cfd68294be82811 = ({ messageId: messageId, onMessageDisposition: onMessageDisposition })=>{
    const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = (0, $ioD1B.useChoreographedStatusContext)();
    const [shouldRender, setShouldRender] = (0, $5uXOq.useState)(false);
    const { startMessage: startMessage, stopMessage: stopMessage } = $596f0fde3f3a2d5a$export$9f0e2488ffd90f11(messageId, {
        start: ()=>setShouldRender(true)
    });
    (0, $5uXOq.useEffect)(()=>{
        if (!isAlreadyChoreographedAtAncestor) {
            const startMessageAsync = async ()=>{
                const disposition = await startMessage();
                onMessageDisposition?.(disposition);
            };
            startMessageAsync();
            return ()=>{
                stopMessage();
            };
        }
    }, [
        onMessageDisposition,
        startMessage,
        stopMessage,
        isAlreadyChoreographedAtAncestor
    ]);
    return shouldRender || isAlreadyChoreographedAtAncestor;
};
const $596f0fde3f3a2d5a$export$a60a99a250d6a89c = ()=>{
    const cleanup = (0, $5uXOq.useRef)();
    const disabled = (0, $5uXOq.useRef)(false);
    if (!disabled.current) {
        cleanup.current = (0, $9ACoj.Choreographer).getInstance().disableChoreographerForIframe();
        disabled.current = true;
    }
    (0, $5uXOq.useEffect)(()=>()=>cleanup.current?.(), []);
};

});
parcelRegister("ioD1B", function(module, exports) {

$parcel$export(module.exports, "ChoreographerContextProvider", () => $c141e5ba3428702a$export$c3226151caaf2fbf);
$parcel$export(module.exports, "useChoreographedStatusContext", () => $c141e5ba3428702a$export$2eb1efa814fe4a);

var $5uXOq = parcelRequire("5uXOq");
const $c141e5ba3428702a$var$choreographedStatusContextValue = {
    isAlreadyChoreographedAtAncestor: true
};
const $c141e5ba3428702a$export$c3226151caaf2fbf = ({ isChoreographed: isChoreographed, children: children })=>{
    const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = $c141e5ba3428702a$export$2eb1efa814fe4a();
    const shouldUseChoreographerContextProvider = !isAlreadyChoreographedAtAncestor && isChoreographed;
    return shouldUseChoreographerContextProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c141e5ba3428702a$export$3ff96dbefca6b00d.Provider, {
        value: $c141e5ba3428702a$var$choreographedStatusContextValue
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
const $c141e5ba3428702a$export$3ff96dbefca6b00d = /*#__PURE__*/ (0, $5uXOq.createContext)({
    isAlreadyChoreographedAtAncestor: false
});
const $c141e5ba3428702a$export$2eb1efa814fe4a = ()=>(0, $5uXOq.useContext)($c141e5ba3428702a$export$3ff96dbefca6b00d);

});



parcelRegister("59YvY", function(module, exports) {

$parcel$export(module.exports, "ChoreographerCommonFlag", () => $3f981fa4d7c05e5a$export$ef12cdd486f28a7a);

var $cSWNW = parcelRequire("cSWNW");

var $6TwEp = parcelRequire("6TwEp");
const $3f981fa4d7c05e5a$export$ef12cdd486f28a7a = (0, $cSWNW.withChoreographedRender)((0, $6TwEp.default));

});
parcelRegister("cSWNW", function(module, exports) {

$parcel$export(module.exports, "withChoreographedRender", () => $620c1a9f3fec1a68$export$c1160fdac17030e);

var $5uXOq = parcelRequire("5uXOq");

var $ioD1B = parcelRequire("ioD1B");

var $fG5AJ = parcelRequire("fG5AJ");
function $620c1a9f3fec1a68$export$c1160fdac17030e(Component) {
    function ChoreographedComponent(props) {
        const { messageId: messageId, onMessageDisposition: onMessageDisposition } = props;
        const shouldRender = (0, $fG5AJ.useChoreographedRender)({
            messageId: messageId,
            onMessageDisposition: onMessageDisposition
        });
        if (shouldRender) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ioD1B.ChoreographerContextProvider), {
            isChoreographed: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, props));
        return null;
    }
    ChoreographedComponent.displayName = `Choreographed${Component.displayName ?? 'Component'}`;
    function WithChoreographedRenderComponent(props) {
        const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = (0, $ioD1B.useChoreographedStatusContext)();
        if (isAlreadyChoreographedAtAncestor) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ChoreographedComponent, props);
    }
    WithChoreographedRenderComponent.displayName = `WithChoreographedRender${Component.displayName ?? 'Component'}`;
    return WithChoreographedRenderComponent;
}

});

parcelRegister("6TwEp", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffb99bb14be92466$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fWXJB = parcelRequire("fWXJB");
var $epfFv = parcelRequire("epfFv");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $6pLjz = parcelRequire("6pLjz");

var $7fDjk = parcelRequire("7fDjk");
const $ffb99bb14be92466$export$b020578ce674a70f = 'platform.ui.flags.common.ui.common-flag-v2';
// standard delay time in ms, added for SR users to announce the status flag
const $ffb99bb14be92466$var$ANNOUNCEMENT_DELAY = 2500;
/**
 * Renders a flag component with dynamic behavior, automatically choosing between auto-dismissing
 * and standard modes based on properties. It dynamically selects an appropriate icon and supports
 * internationalization and accessibility, making it versatile for various use cases.
 */ const $ffb99bb14be92466$var$CommonFlag = (props)=>{
    const { flagType: flagType, icon: icon, delayAnnouncement: delayAnnouncement = $ffb99bb14be92466$var$ANNOUNCEMENT_DELAY, isAutoDismiss: isAutoDismiss, ...flagProps } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const StyledIcon = flagProps.appearance ? (0, $6pLjz.boldIconMap)[flagType] : (0, $6pLjz.iconMap)[flagType];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $ffb99bb14be92466$var$containerStyles,
        ...flagProps.testId && {
            'data-test-id': flagProps.testId
        }
    }, isAutoDismiss ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fWXJB.default), {
        testId: `${$ffb99bb14be92466$export$b020578ce674a70f}-auto-dismiss`,
        ...flagProps,
        delayAnnouncement: delayAnnouncement,
        icon: icon ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(StyledIcon, {
            label: formatMessage((0, $7fDjk.messages)[flagType])
        }) ?? null
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $epfFv.default), {
        testId: $ffb99bb14be92466$export$b020578ce674a70f,
        ...flagProps,
        delayAnnouncement: delayAnnouncement,
        icon: icon ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(StyledIcon, {
            label: formatMessage((0, $7fDjk.messages)[flagType])
        }) ?? null
    }));
};
var $ffb99bb14be92466$export$2e2bcd8739ae039 = $ffb99bb14be92466$var$CommonFlag;
const $ffb99bb14be92466$var$containerStyles = (0, $8CUq3.xcss)({
    wordWrap: 'break-word'
});

});
parcelRegister("6pLjz", function(module, exports) {

$parcel$export(module.exports, "iconMap", () => $38acb16b2f8a5dd3$export$6d49a893c897b0cc);
$parcel$export(module.exports, "boldIconMap", () => $38acb16b2f8a5dd3$export$6c71c95b1e390472);

var $jEF9d = parcelRequire("jEF9d");
const $38acb16b2f8a5dd3$export$6d49a893c897b0cc = {
    error: (0, $jEF9d.IconError),
    success: (0, $jEF9d.IconSuccess),
    info: (0, $jEF9d.IconInfo),
    warning: (0, $jEF9d.IconWarning)
};
const $38acb16b2f8a5dd3$export$6c71c95b1e390472 = {
    error: (0, $jEF9d.BoldIconError),
    success: (0, $jEF9d.BoldIconSuccess),
    info: (0, $jEF9d.BoldIconInfo),
    warning: (0, $jEF9d.BoldIconWarning)
};

});
parcelRegister("jEF9d", function(module, exports) {

$parcel$export(module.exports, "IconError", () => $29d87fe42743cbe5$export$66493327321323ad);
$parcel$export(module.exports, "IconSuccess", () => $29d87fe42743cbe5$export$9cae035d1b6ae1dc);
$parcel$export(module.exports, "IconInfo", () => $29d87fe42743cbe5$export$340bfce9b4df026b);
$parcel$export(module.exports, "IconWarning", () => $29d87fe42743cbe5$export$5be70e40251e6f9b);
$parcel$export(module.exports, "BoldIconError", () => $29d87fe42743cbe5$export$4d6c0ef1e9e095ae);
$parcel$export(module.exports, "BoldIconSuccess", () => $29d87fe42743cbe5$export$23fdc8fccd51d997);
$parcel$export(module.exports, "BoldIconInfo", () => $29d87fe42743cbe5$export$4c05116eb19cc3aa);
$parcel$export(module.exports, "BoldIconWarning", () => $29d87fe42743cbe5$export$522238647b7d04fc);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $c2i4s = parcelRequire("c2i4s");

var $dD7Zc = parcelRequire("dD7Zc");

var $1jWct = parcelRequire("1jWct");

var $bU3PY = parcelRequire("bU3PY");
const $29d87fe42743cbe5$export$66493327321323ad = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($29d87fe42743cbe5$export$8f314e512d92575f, {
        iconColor: "var(--ds-icon-danger, #C9372C)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
        spacing: "spacious",
        label: label
    }));
const $29d87fe42743cbe5$export$9cae035d1b6ae1dc = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($29d87fe42743cbe5$export$8f314e512d92575f, {
        iconColor: "var(--ds-icon-success, #22A06B)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c2i4s))), {
        spacing: "spacious",
        label: label
    }));
const $29d87fe42743cbe5$export$340bfce9b4df026b = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($29d87fe42743cbe5$export$8f314e512d92575f, {
        iconColor: "var(--ds-icon-discovery, #8270DB)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1jWct))), {
        spacing: "spacious",
        label: label
    }));
const $29d87fe42743cbe5$export$5be70e40251e6f9b = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($29d87fe42743cbe5$export$8f314e512d92575f, {
        iconColor: "var(--ds-icon-warning, #E56910)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))), {
        spacing: "spacious",
        label: label
    }));
const $29d87fe42743cbe5$export$4d6c0ef1e9e095ae = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
        spacing: "spacious",
        label: label,
        LEGACY_secondaryColor: "var(--ds-icon-danger, #C9372C)"
    });
const $29d87fe42743cbe5$export$23fdc8fccd51d997 = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c2i4s))), {
        spacing: "spacious",
        label: label,
        LEGACY_secondaryColor: "var(--ds-icon-success, #22A06B)"
    });
const $29d87fe42743cbe5$export$4c05116eb19cc3aa = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1jWct))), {
        spacing: "spacious",
        label: label,
        LEGACY_secondaryColor: "var(--ds-icon-discovery, #8270DB)"
    });
const $29d87fe42743cbe5$export$522238647b7d04fc = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))), {
        spacing: "spacious",
        label: label,
        LEGACY_secondaryColor: "var(--ds-icon-warning, #E56910)"
    });
const $29d87fe42743cbe5$export$8f314e512d92575f = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { iconColor: iconColor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1weumv": (0, $lD23V.default)(__cmplp.iconColor)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1kah",
            __cmplp.className
        ])
    });
});

});


parcelRegister("7fDjk", function(module, exports) {

$parcel$export(module.exports, "messages", () => $de522aa55d5b135d$export$defe85febe8b728c);
// Should not remove this disabled-line and don't run eslint --fix for this file

var $7VHMR = parcelRequire("7VHMR");
const $de522aa55d5b135d$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    error: {
        "id": "platform.flags.common.components.common-flag.error",
        "defaultMessage": "Error"
    },
    success: {
        "id": "platform.flags.common.components.common-flag.success",
        "defaultMessage": "Success"
    },
    info: {
        "id": "platform.flags.common.components.common-flag.info",
        "defaultMessage": "Information"
    },
    warning: {
        "id": "platform.flags.common.components.common-flag.warning",
        "defaultMessage": "Warning"
    }
});

});






//# sourceMappingURL=async-flags-v2.bf466cff.js.map
